import React, { Component } from 'react';
import { compose } from 'recompose';
import {
  withRouter,
} from 'react-router-dom';

import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import SignUpForm from './SignUpForm';
import { SignInLink } from './SignIn';

import bg from './bg-02.jpg';
import couraggoIcon from 'img/couraggo-64.png';

const styles = theme => ({
  root: {
    minHeight: '100vh',
    backgroundImage: `url(${bg})`,
    backgroundSize: 'cover',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    width: "400px",
    display: "flex",
    flexDirection: "column",
  },
  title: {
    alignSelf: "center",
    marginTop: theme.spacing.unit*2,
  },
  subtitle: {
    alignSelf: "center",
  }
});

const SignUpPage = ({ classes, history }) =>
  <div className={classes.root}>
    <Card className={classes.card}>
        <img
          style={{
            marginTop: '10px',
            opacity: 0.5,
            alignSelf: 'center',
            width: '40px',
            height: '40px'
          }}
          alt="Couraggo Icon"
          src={couraggoIcon}
        />
      <Typography style={{ alignSelf: 'center' }} variant="caption">
        Couraggo
      </Typography>
      <Typography className={classes.title} variant="headline">
        Try Couraggo for free
      </Typography>
      <Typography className={classes.subtitle} variant="caption">
        Easily build a website. Save time on paperwork. Look pro.
      </Typography>
      <SignUpForm history={history} />
    </Card>
  </div>

export default compose(
  withRouter,
  withStyles(styles)
)(SignUpPage);



// WEBPACK FOOTER //
// ./src/components/auth/SignUp.jsx